import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuditService, ConfigService, DeliveryCompany, OrderType, OrderTypeConfig } from 'ngx-web-api';
import { Observable } from 'rxjs';
import { Animations } from '../../animations';

@Component({
  selector: 'fts-order-type-chooser',
  templateUrl: './order-type-chooser.component.html',
  styleUrls: ['./order-type-chooser.component.scss'],
  animations: [Animations.expanded],
})
export class OrderTypeChooserComponent implements OnInit {
  @Input()
  selectedOrderType: OrderType;
  @Input()
  isInHome: boolean;
  @Output()
  onOrderTypeChange: EventEmitter<OrderType> = new EventEmitter<OrderType>(true);
  @Output()
  onOrderAheadChange: EventEmitter<boolean> = new EventEmitter<boolean>(true);
  orderTypes: OrderTypeConfig[];
  selectedOrderTypeConfig: OrderTypeConfig;
  description: string;
  deliveryCompanies$: Observable<DeliveryCompany[]>;
  orderAheadConfig: OrderTypeConfig;
  isOrderAheadSelected = false;
  readonly ORDER_AHEAD_VALUE = '__ORDER_AHEAD__';

  constructor(private configService: ConfigService, private auditService: AuditService) {}

  ngOnInit() {
    this.configService.orderTypesConfig$.subscribe(orderTypes => {
      this.orderTypes = orderTypes.filter(ot => !ot.isOrderAhead);
      this.showDescription(this.selectedOrderType);
    });
    this.configService.allOrderTypesConfig$.subscribe(allOrderTypes => {
      this.orderAheadConfig = allOrderTypes.find(ot => ot.isOrderAhead);
    });
    this.deliveryCompanies$ = this.configService.deliveryCompanies$;
  }

  showDescription(orderType: OrderType) {
    this.selectedOrderTypeConfig = this.orderTypes[this.orderTypes.map(type => type.type).indexOf(orderType)];
    this.description =
      this.selectedOrderTypeConfig && this.selectedOrderTypeConfig.description ? this.selectedOrderTypeConfig.description : '';
  }

  chooseOrderType(orderType: OrderType | string) {
    if (orderType === this.ORDER_AHEAD_VALUE) {
      this.isOrderAheadSelected = true;
      const actualOrderType = this.orderAheadConfig.type;
      this.showDescription(actualOrderType);
      this.onOrderTypeChange.next(actualOrderType);
      this.onOrderAheadChange.next(true);
      this.auditService.createAudit(() => `Setting order type to Order Ahead (${actualOrderType})`);
    } else {
      this.isOrderAheadSelected = false;
      this.showDescription(orderType as OrderType);
      this.onOrderTypeChange.next(orderType as OrderType);
      this.onOrderAheadChange.next(false);
      this.auditService.createAudit(() => `Setting order type to ${orderType}`);
    }
  }

  get selectedRadioValue(): OrderType | string {
    if (this.isOrderAheadSelected) {
      return this.ORDER_AHEAD_VALUE;
    }
    return this.selectedOrderType;
  }
}
